import { render, staticRenderFns } from "./IcnIndustry.vue?vue&type=template&id=2d85ed78&"
import script from "./IcnIndustry.vue?vue&type=script&lang=ts&"
export * from "./IcnIndustry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports